import createSettingsActions from "./actions";
import { dispatchAppStateAction } from "../../../appState";

export default createSettingsActions({
	dispatchAppStateAction: dispatchAppStateAction,
});
